module.exports = "<app-discount-group-person-list></app-discount-group-person-list>"